import { useEffect } from "react";
import useSPQS from "../../../hooks/useSPQS";
import useSPQSUndo from "../../../hooks/useSPQSUndo";

const useLoadSPQSToEdit = (
  axiosPrivate,
  qstoeditSP,
  setSPQS,
  setSPQSData,
  setPpaymentterm,
  setPpaymenttermData,
  ppaytermInit,
  ppaytermDataInit,
  setLoaded,
  navigate,
  location,
  setSpaymentterm,
  setSpaymenttermData,
  spaytermInit,
  spaytermDataInit,
  setShowSQSM,
  setSQSM,
  setNavpostoedit
) => {
  const { SPQSEdits, undoListSPQS } = useSPQSUndo();
  const { setWhdataSP } = useSPQS();

  useEffect(() => {
    if (qstoeditSP) {
      const loadqsvalstoedit = async () => {
        try {
          const response = await axiosPrivate.post("/api/qs/loadspqstoedit", {
            SPQSID: qstoeditSP,
          });
          setSPQS(response.data[0]);
          setLoaded((prev) => !prev);
          SPQSEdits.current = [];
          undoListSPQS.current = [];
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadqsdatatoedit = async () => {
        try {
          await axiosPrivate
            .post("/api/qs/loadspqsdatatoedit", {
              SPQSID: qstoeditSP,
            })
            .then(async (response) => {
              setSPQSData(response.data[0]);
              await axiosPrivate.post("/api/qs/loadSPQSwhadata", { WGP: response.data[0].WGP }).then((response1) => {
                if (response1.message === "No matching WGP.") {
                  return;
                }
                if (response1.data && response1.data.length > 0) {
                  setWhdataSP(response1.data[0]);
                  setNavpostoedit(response1.data[0].USposID);
                }
              });
            });
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadQSpayterms = async () => {
        try {
          const response = await axiosPrivate.post("/api/qs/loadSPQSpayterms", {
            SPQSID: qstoeditSP,
          });
          if (response.data.message === "No payterms exist.") {
            setPpaymentterm(ppaytermInit);
            setSpaymentterm(spaytermInit);
          } else {
            let ppayterms = response.data.filter((item) => item.origin === "purchase");
            let spayterms = response.data.filter((item) => item.origin === "sales");
            setPpaymentterm(ppayterms);
            setSpaymentterm(spayterms);
          }
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadQSpaytermsdata = async () => {
        try {
          const response = await axiosPrivate.post("/api/qs/loadSPQSpaytermsdata", {
            SPQSID: qstoeditSP,
          });
          if (response.data.message === "No payterms exist.") {
            setPpaymenttermData(ppaytermDataInit);
            setSpaymenttermData(spaytermDataInit);
          } else {
            let ppaytermsdata = response.data.filter((item) => item.origin === "purchase");
            let spaytermsdata = response.data.filter((item) => item.origin === "sales");
            setPpaymenttermData(ppaytermsdata);
            setSpaymenttermData(spaytermsdata);
          }
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };

      loadqsvalstoedit();
      loadqsdatatoedit();
      loadQSpayterms();
      loadQSpaytermsdata();
      setSQSM("Spain QS loaded");
      setShowSQSM((prev) => !prev);
    }
  }, [qstoeditSP]);
};

export default useLoadSPQSToEdit;
